import React, { useEffect, useState } from 'react';
import { Send, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { RichTextEditor } from '../../../components/RichTextEditor';
import { errMsg } from './crmConstants';

// Preview + per-lead edit before sending. template = null → free email.
export const EmailComposeDialog = ({ open, onClose, api, lead, template, showToast, onSent }) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSubject(''); setBody('');
    if (!template) return;
    setLoading(true);
    api.post(`/admin/leads/${lead.id}/email/preview`, { template: template.key })
      .then((r) => { setSubject(r.subject); setBody(r.body); })
      .catch((e) => showToast('error', errMsg(e)))
      .finally(() => setLoading(false));
  }, [open, template, lead.id]);

  const send = async () => {
    setSending(true);
    try {
      const r = await api.post(`/admin/leads/${lead.id}/email`, { template: template?.key || 'custom', subject, body, language: 'it' });
      showToast('success', `Email inviata: ${r.subject}`);
      onSent(); onClose();
    } catch (e) { showToast('error', errMsg(e, 'Invio fallito')); }
    setSending(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl bg-slate-800 border-slate-700 text-white max-h-[92vh] overflow-y-auto z-[90]" data-testid="email-compose-dialog">
        <DialogHeader>
          <DialogTitle>{template ? template.name : 'Email personalizzata'}</DialogTitle>
          <DialogDescription className="text-slate-400">A: {lead.email} · le modifiche valgono solo per questo invio.</DialogDescription>
        </DialogHeader>
        {loading ? <Loader2 className="w-6 h-6 animate-spin text-slate-400 mx-auto my-10" /> : (
          <div className="space-y-3">
            <input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Oggetto" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm font-semibold" data-testid="compose-subject-input" />
            <div data-testid="compose-body-editor"><RichTextEditor key={`${template?.key || 'custom'}-${subject ? 1 : 0}`} value={body} onChange={setBody} placeholder="Scrivi il testo dell'email…" minHeight={220} /></div>
            <div className="flex justify-end gap-2">
              <Button variant="ghost" onClick={onClose} className="text-slate-300 hover:bg-slate-700" data-testid="compose-cancel-btn">Annulla</Button>
              <Button onClick={send} disabled={sending || !subject.trim() || !body.replace(/<[^>]+>/g, '').trim()} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="compose-send-btn">
                {sending ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Send className="w-4 h-4 mr-1" />} Invia a {lead.name?.split(' ')[0] || 'lead'}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
